import vue from 'vue'
import axios from './axios'
import apiAdmin from './admin'

const apiContent = {
    //账号登录
    login: (data) => {
        return axios('/Home/Index/Login', data)
    },
    // 微信登录
    wxlogin: (data) => {
        return axios('/home/Index/wx_login', data)
    },
    // 微信绑定
    bdWx: (data) => {
        return axios('/home/User/Wx_db', data)
    },
    // 手机号绑定
    bindPhone: (data) => {
        return axios('/home/Index/BdPhone', data)
    },
    // 发送验证码
    sendNum: (data) => {
        return axios('/Home/Index/sms_send', data)
    },
    // 微信登录
    findpass: (data) => {
        return axios('/home/Index/FindPass', data)
    },
    // 验证码登录
    sendNumLogin: (data) => {
        return axios('/Home/Index/sms_login', data)
    },
    // 手机号注册
    register: (data) => {
        return axios('/Home/Index/sms_reg', data)
    },
    // 手机号注册
    CheckPhone: (data) => {
        return axios('/home/Index/CheckPhone', data)
    },
    // 益书宝协议
    Getxieyi: (data) => {
        return axios('/home/Index/Getxieyi', data)
    },
    //  单点登录
    dandian: (data) => {
    return axios('/Home/Index/Synchronouslogin', data)
},
}
const api = {
    apiContent,
    apiAdmin
}
vue.prototype.$api = api
